// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar[data-v-88167522]  .b-sidebar{background-color:#eaedf4!important}.sidebar[data-v-88167522]  .b-sidebar .nav-link.active{color:#2e4787}.nav-item-child[data-v-88167522],.nav-item-child .nav-link.active[data-v-88167522]{background-color:#dadfea}.nav-item-child .nav-link.active[data-v-88167522]:after{background-color:#2e4787}", ""]);
// Exports
module.exports = exports;
